<template>
  <div ref="toolTip" :class="bemBlock">
    <component :is="'style'" v-if="styles" v-html="styles" />
    <div :data-tooltip-type="type" />
  </div>
</template>

<script>
import bemClassesMixin from '../mixins/bemClassesMixin';

const { createTooltip } = require('../../components/tooltips');

export default {
  name: 'BaseTooltip',

  mixins: [bemClassesMixin],

  props: {
    type: {
      type: String,
      required: false,
      default: null,
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
    text: {
      type: String,
      required: false,
      default: null,
    },
    button: {
      type: String,
      required: false,
      default: null,
    },
    showCloseBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: Object,
      required: false,
      default: () => ({
        background: null,
        text: null,
        closeBtn: null,
      }),
    },
    notDestroyOnClose: {
      type: Boolean,
      required: false,
      default: false,
    },
    position: {
      type: String,
      required: false,
      default: 'top',
    },
    saveSession: {
      type: Boolean,
      required: false,
      default: false,
    },
    cookieExpiredType: {
      type: Boolean,
      required: false,
      default: false,
    },
    cookieAge: {
      type: Number,
      required: false,
      default: 0,
    },
    timeToShow: {
      type: Number,
      required: false,
      default: 3000,
    },
    animation: {
      type: Object,
      required: false,
      default: () => ({
        animationEnabled: false,
        animationEnabledDesktop: false,
        animationBreakpoint: 1024,
        animationImage: null,
        animationImageDesktop: null,
      }),
    },
    callCloseEvent: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      toolTip: null,
      styles: null,
      closeEventCalled: false,
    };
  },

  watch: {
    callCloseEvent() {
      if (this.callCloseEvent && !this.closeEventCalled && this.toolTip) {
        this.closeEventCalled = true;
        this.hide();
      }
    },
  },

  mounted() {
    this.createTooltip();
    this.createAnimationStyles();
  },

  beforeDestroy() {
    this.toolTip?.buttonElement?.removeEventListener(
      'click',
      this.onTooltipClick
    );
  },

  methods: {
    createTooltip() {
      this.toolTip = createTooltip({
        type: this.type,
        title: this.title,
        text: this.text,
        button: this.button,
        showCloseBtn: this.showCloseBtn,
        color: this.color,
        position: this.position,
        saveSession: this.saveSession,
        cookieExpiredType: this.cookieExpiredType,
        cookieAge: this.cookieAge,
      });
      if (!this.toolTip) return;

      this.toolTip?.buttonElement?.addEventListener(
        'click',
        this.onTooltipClick
      );

      setTimeout(this.show, this.timeToShow);
    },

    hide() {
      this.toolTip?.closeEvent();
      this.$emit('tooltip-hide');
    },

    show() {
      this.toolTip?.show();
      this.$emit('tooltip-show');
    },

    onTooltipClick() {
      this.toolTip?.hide();
      this.$emit('tooltip-click');
    },

    createAnimationStyles() {
      if (!this.toolTip || !this.animation?.animationEnabled) return;
      const animationClassName = `tooltip-animation-${Math.floor(Math.random() * 10000)}`;
      this.toolTip.selector?.classList.add(
        animationClassName,
        'animation-image-frontface'
      );
      this.styles = `
        @media (max-width: ${this.animation.animationBreakpoint}px) {
          .${animationClassName}.animation-image-frontface::before {
            display: block;
            background-image: url('${this.animation.animationImage}');
          }
        }
        @media (min-width: ${this.animation.animationBreakpoint + 1}px) {
          .${animationClassName}.animation-image-frontface::before {
            display: block;
            background-image: url('${this.animation.animationImageDesktop}');
          }
        }
      `;
    },
  },
};
</script>
